import { c as _c } from "react/compiler-runtime";
/**
 * Schema-related data fetchers
 */
import { useQuery } from "@tanstack/react-query";
import { ConfigMap, EnabledFieldsMap, RequestedFieldsMap } from "@/src/lib/schema-types";
import { getConfig, getEnabledFields, getRequestedFields } from "@/src/requests/schema";
export function useEnabledFields() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      queryKey: ["enabledFields"],
      queryFn: getEnabledFields,
      staleTime: Infinity,
      gcTime: Infinity
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return useQuery(t0);
}
export function useRequestedFields() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      queryKey: ["requestedFields"],
      queryFn: getRequestedFields,
      staleTime: Infinity,
      gcTime: Infinity
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return useQuery(t0);
}
export function useConfig() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      queryKey: ["config"],
      queryFn: getConfig,
      staleTime: Infinity,
      gcTime: Infinity
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return useQuery(t0);
}